import { removeTimeZone } from "@swa-ui/date";

// TODO: Explore updating swa-ui-date to add custom date format to removeTimeZone SPASHOP-1055.
// TODO: Remove this function when Vision is decommisioned.
// const CT_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss";

/**
 * This function takes a list of "fares" (Flight segments for a trip) as per Southwest API response standards,
 * and transforms them into CarTrawler data structure for flights information.
 *
 * @param {Array} fares List of flights structured as per SWA API response contract.
 * @returns {Object} Flight legs formatted as per CarTrawler data structure.
 */
export const generateFlightInformationForCarSection = (fares = []) => {
  const legs = [];
  const outboundLastStop = fares?.[0]?.stopsDetails?.at(-1);

  if (outboundLastStop) {
    const operatingCarrierCode = outboundLastStop.operatingCarrierCode;
    const outboundLeg = {
      arrival: {
        datetime: removeTimeZone(outboundLastStop.arrivalDateTime),
        iata: outboundLastStop.destinationAirportCode,
      },
      departure: {
        datetime: removeTimeZone(outboundLastStop.departureDateTime),
        iata: outboundLastStop.originationAirportCode,
      },
      flightNo: `${operatingCarrierCode}${outboundLastStop.flightNumber}`,
      key: "outbound",
    };

    legs.push(outboundLeg);
  }

  const inboundFirstStop = fares?.[1]?.stopsDetails?.at(0);

  if (inboundFirstStop) {
    const operatingCarrierCode = inboundFirstStop.operatingCarrierCode;
    const inboundLeg = {
      arrival: {
        datetime: removeTimeZone(inboundFirstStop.arrivalDateTime),
        iata: inboundFirstStop.destinationAirportCode,
      },
      departure: {
        datetime: removeTimeZone(inboundFirstStop.departureDateTime),
        iata: inboundFirstStop.originationAirportCode,
      },
      flightNo: `${operatingCarrierCode}${inboundFirstStop.flightNumber}`,
      key: "inbound",
    };

    legs.push(inboundLeg);
  }

  return {
    legs,
  };
};
